import React from "react";
import * as ReactDOMClient from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import App from "./src/App";
import { SnackbarProvider } from "notistack";

import "./bootstrap";
import "@/i18n";

import { store } from "./src/redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

import {
  authProtectedRoutes,
  publicRoutes,
  RoutesProps,
  flattenRoutesWithFullPath 
} from "@/routes/index";

import Error404 from "@/pages/error/Error404";

import PrivateRoute from "@/routes/PrivateRoute";

const storePersistor = persistStore(store);
const container = document.getElementById("app")!;
const root = ReactDOMClient.createRoot(container);

const mapToRouteObjects = (routes: RoutesProps[]): any[] =>
  routes.map((r) => {
    const route: any = {
      path: r.path,
      element:
        r.route === PrivateRoute ? (
          <PrivateRoute>{r.element}</PrivateRoute>
        ) : (
          r.element
        ),
    };

    if (r.children) {
      route.children = mapToRouteObjects(r.children);
    }

    return route;
});

const prflat = flattenRoutesWithFullPath(publicRoutes);
const protrflat = flattenRoutesWithFullPath(authProtectedRoutes);

const router = createBrowserRouter([
  {
    path: "",
    element: <App />,
    errorElement: <Error404 />,
    children: [
        ...mapToRouteObjects(flattenRoutesWithFullPath(publicRoutes)),
        ...mapToRouteObjects(flattenRoutesWithFullPath(authProtectedRoutes)),
    ],
  },
]);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={storePersistor}>
      <SnackbarProvider>
        <RouterProvider router={router} />
      </SnackbarProvider>
    </PersistGate>
  </Provider>
);


